import { ThemeOptions } from '@mui/system';

const BORDER_RADIUS = 8;

export const shape: ThemeOptions['shape'] = {
  borderRadius: BORDER_RADIUS,
};
